import { WorkspaceFoldersChangeEvent, NotificationHandler } from 'vscode-languageserver-protocol';
import { createInterfaceId, Injectable } from '@gitlab-org/di';
import { HandlesNotification } from '../../handler';
import { ConfigService } from '../../config_service';

export interface DidChangeWorkspaceFoldersHandler
  extends HandlesNotification<WorkspaceFoldersChangeEvent> {}

export const DidChangeWorkspaceFoldersHandler =
  createInterfaceId<DidChangeWorkspaceFoldersHandler>('InitializeHandler');

@Injectable(DidChangeWorkspaceFoldersHandler, [ConfigService])
export class DefaultDidChangeWorkspaceFoldersHandler implements DidChangeWorkspaceFoldersHandler {
  #configService: ConfigService;

  constructor(configService: ConfigService) {
    this.#configService = configService;
  }

  notificationHandler: NotificationHandler<WorkspaceFoldersChangeEvent> = (
    params: WorkspaceFoldersChangeEvent,
  ): void => {
    const { added, removed } = params;

    const removedKeys = removed.map(({ name }) => name);

    const currentWorkspaceFolders = this.#configService.get('client.workspaceFolders') || [];
    const afterRemoved = currentWorkspaceFolders.filter((f) => !removedKeys.includes(f.name));
    const afterAdded = [...afterRemoved, ...(added || [])];

    this.#configService.set('client.workspaceFolders', afterAdded);
  };
}
